import { render, staticRenderFns } from "./form-feedback.vue?vue&type=template&id=0f5a1ce8&scoped=true"
import script from "./form-feedback.vue?vue&type=script&lang=js"
export * from "./form-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a1ce8",
  null
  
)

export default component.exports